import { apiRequest } from "./CmnService";

// Start Request a Quote

export const QuotesRequestService = async (data, cb) => {
  return apiRequest("POST", "add_request_for_qoute", data, cb);
};

export const QuotesContentService = async (cb) => {
  return apiRequest("GET", "getRequestQouteContent", null, cb);
};

// End Request a Quote
// Start Manage Travelers

export const addManageTravelService = async (data, cb) => {
  return apiRequest("POST", "add_manage_travel", data, cb);
}
export const editTravellerService = async (data, cb) => {
  return apiRequest("POST", "edit_manage_travel", data, cb);
}
export const deleteTravellerService = async (data, cb) => {
  return apiRequest("POST", "delete_manage_travel", data, cb);
}
export const activeDeactiveTravelService = async (data, cb) => {
  return apiRequest("POST", "active_deactive_manage_travel", data, cb);
}
export const getManageTravelService = async (data, cb) => {
  return apiRequest("POST", "get_manage_travel", data, cb);
}

// End Manage Travelers
// Start Manage Itineraries
export const createItinerariesApi = async (data, cb) => {
  return apiRequest("POST", "CreateItineraryBackup", data, cb);
};
export const editItinerariesApi = async (data, cb) => {
  return apiRequest("POST", "edit_itinerary_data", data, cb);
};
export const getItinerariesApi = async (data, cb) => {
  return apiRequest("POST", "get_itinerary_data_backup", data, cb);
};
export const getDraftAllApi = async (data, cb) => {
  return apiRequest("POST", "get_all_itinerary_list_backup", data, cb);
};

export const addActivityApi = async (data, cb) => {
  return apiRequest("POST", "add_activity_data", data, cb);
};

export const editActivityApi = async (data, cb) => {
  return apiRequest("POST", "edit_activity_data", data, cb);
};

export const addFoodRestaurentApi = async (data, cb) => {
  return apiRequest("POST", "add_food_restaurant_data", data, cb);
};

export const editFoodRestaurentApi = async (data, cb) => {
  return apiRequest("POST", "edit_food_restaurant_data", data, cb);
};
export const addStayApi = async (data, cb) => {
  return apiRequest("POST", "add_stay", data, cb);
};

export const editStayApi = async (data, cb) => {
  return apiRequest("POST", "edit_stay", data, cb);
};
export const addOthersApi = async (data, cb) => {
  return apiRequest("POST", "add_others", data, cb);
};

export const editOthersApi = async (data, cb) => {
  return apiRequest("POST", "edit_others", data, cb);
};

export const addTourApi = async (data, cb) => {
  return apiRequest("POST", "add_tour", data, cb);
};
export const editTourApi = async (data, cb) => {
  return apiRequest("POST", "edit_tour", data, cb);
};

export const addTransportApi = async (data, cb) => {
  return apiRequest("POST", "add_transport", data, cb);
};
export const editTransportApi = async (data, cb) => {
  return apiRequest("POST", "edit_transport", data, cb);
};

export const deleteItineraryDaysDataApi = async (data, cb) => {
  return apiRequest("POST", "delete_itinerary_days_data", data, cb);
};
export const deleteDestinationCityApi = async (data, cb) => {
  return apiRequest("POST", "itinerary_destination_city_remove", data, cb);
};
export const deleteDestinationCityDaysApi = async (data, cb) => {
  return apiRequest("POST", "itinerary_destination_city_days_remove", data, cb);
};
export const getUserPublicPrivateListApi = async (data, cb) => {
  return apiRequest("POST", "get_user_private_public_intineray_list", data, cb);
};
export const updateItineraryPublishApi = async (data, cb) => {
  return apiRequest("POST", "update_itinerary_publish_status", data, cb);
};

export const removeItineraryApi = async (data, cb) => {
  return apiRequest("POST", "remove_itinerary", data, cb);
};
export const getUserItineraryCountApi = async (data, cb) => {
  return apiRequest("POST", "get_user_public_private_stays_itinerary_count", data, cb);
};
export const mergeItineraryApi = async (data, cb) => {
  return apiRequest("POST", "marge_itinerary", data, cb);
};

export const addExistingTripApi = async (data, cb) => {
  return apiRequest("POST", "CreateItineraryBackupExistingTrip", data, cb);
};

export const getUserItineraryListApi = async (data, cb) => {
  return apiRequest("POST", "get_user_itinerary_list", data, cb);
};
export const getUserItineraryCityListApi = async (data, cb) => {
  return apiRequest("POST", "get_user_itinerary_city_list", data, cb);
};

export const getFoodListService = async ({ page, pageSize, shortName, newCurrency }, cb) => {
  const fullURL = `user-food-list?page=${page}&pageSize=${pageSize}`;
  const data = { shortName, newCurrency };
  return apiRequest("POST", fullURL, data, cb);
};

export const getActivityListService = async ({ page, pageSize, shortName, newCurrency }, cb) => {
  const fullURL = `user-activity-list?page=${page}&pageSize=${pageSize}`;
  const data = { shortName, newCurrency };
  return apiRequest("POST", fullURL, data, cb);
};

export const getStayListService = async ({ page, pageSize, shortName, newCurrency }, cb) => {
  const fullURL = `user-stay-list?page=${page}&pageSize=${pageSize}`;
  const data = { shortName, newCurrency };
  return apiRequest("POST", fullURL, data, cb);
};

export const getTourListService = async ({ page, pageSize, shortName, newCurrency }, cb) => {
  const fullURL = `user-tour-list?page=${page}&pageSize=${pageSize}`;
  const data = { shortName, newCurrency };
  return apiRequest("POST", fullURL, data, cb);
};

export const getOtherListService = async ({ page, pageSize, shortName, newCurrency }, cb) => {
  const fullURL = `user-other-list?page=${page}&pageSize=${pageSize}`;
  const data = { shortName, newCurrency };
  return apiRequest("POST", fullURL, data, cb);
};

export const getTranspotListService = async ({ page, pageSize, shortName, newCurrency, types }, cb) => {
  const fullURL = `user-transport-list?page=${page}&pageSize=${pageSize}`;
  const data = { shortName, newCurrency, types };
  return apiRequest("POST", fullURL, data, cb);
};

// End  Manage Itineraries
// Start  Manage Subscription

export const getSubscriptionPlanByIdApi = async (data, cb) => {
  return apiRequest("POST", "get_subscription_plan_by_id", data, cb);
};

export const SaveCardService = async (data, cb) => {
  return apiRequest("POST", "save_card", data, cb);
}

export const CreateSubscriptionService = async (data, cb) => {
  return apiRequest("POST", "create_subscription", data, cb);
}

export const CancelSubscriptionService = async (data, cb) => {
  return apiRequest("POST", "cancel_subscription", data, cb);
}

export const SaveCardListService = async (data, cb) => {
  return apiRequest("POST", "list_card", data, cb);
}

export const getPaymentHistoryListService = async ({ page, pageSize, newCurrency }, cb) => {
  const fullURL = `get_invoices_list?page=${page}&pageSize=${pageSize}`;
  const data = { newCurrency };
  return apiRequest("POST", fullURL, data, cb);
}

export const deleteCardService = async (data, cb) => {
  return apiRequest("POST", "delete_card", data, cb);
}

export const changeDefaultCardService = async (data, cb) => {
  return apiRequest("POST", "change_default_card", data, cb);
}

export const getSubscriptionStatusService = async (data, cb) => {
  return apiRequest("POST", "get_subscription_status", data, cb);
}
// End  Manage Subscription